import { ssoFallbackUrl } from "@iec-id/shared";

/**
 * Адрес входа экосистемы — ОДНО место на всю витрину.
 *
 * ПОЧЕМУ ЗДЕСЬ, А НЕ В `session.ts`. Адрес нужен трём несвязанным поверхностям:
 * перехватчику 401, кнопке «Выйти» и ссылке на публичный текст про cookie.
 * Пока константа жила в модуле про истёкшую сессию, правовой контур зависел от
 * механики 401 — а разъезжаются такие зависимости молча.
 *
 * Сам ВЫБОР адреса (`auth.` в бою, локальный в разработке, никогда `sso.`)
 * живёт в `@iec-id/shared` → `constants/sso.ts`: он одинаков для витрины и
 * админки, и однажды они уже разъехались, держа его каждый у себя.
 */
export const SSO_URL: string =
	import.meta.env.VITE_SSO_URL ?? ssoFallbackUrl(import.meta.env.DEV === true);

/** Адрес без хвостового слэша — для склейки путей (`/legal/cookies`). */
export function ssoOrigin(): string {
	return SSO_URL.replace(/\/+$/, "");
}

/** Адрес формы входа с возвратом на `returnTo` (по умолчанию — текущая страница). */
export function ssoSignInUrl(returnTo?: string): string {
	const target = returnTo ?? (typeof window === "undefined" ? "" : window.location.href);
	try {
		const url = new URL(SSO_URL);
		if (target) url.searchParams.set("redirect_to", target);
		return url.toString();
	} catch {
		return SSO_URL;
	}
}
